import ProductTypeTabs from '@/components/product/product-tabs';
import ProductSearchBar from '@/components/product/product-searchbar';
import { useBreakpoint } from '@/lib/hooks/use-breakpoint';
import { useIsDarkMode } from '@/lib/hooks/use-is-dark-mode';

const ProductSearch = ({
  isInstantSearch = true,
  searchRef,
  context = 'marketplace',
  hideTabs = false,
}: {
  isInstantSearch?: boolean;
  searchRef: React.RefObject<HTMLInputElement>;
  context?: 'marketplace' | 'header';
  hideTabs?: boolean;
}) => {
  const breakpoint = useBreakpoint();
  const { isDarkMode } = useIsDarkMode();

  return (
    <div className="flex flex-col gap-0" style={{ isolation: 'isolate' }}>
      {!hideTabs && <ProductTypeTabs />}
      <div className="relative mt-4" style={{ zIndex: 50 }}>
        <ProductSearchBar
          id="primary-search-bar"
          searchRef={searchRef}
          isInstantSearch={isInstantSearch}
          context={context}
          onFocus={() => {
            if (breakpoint === 'xs' || breakpoint === 'sm') {
              setTimeout(() => {
                searchRef.current?.scrollIntoView({
                  behavior: 'instant',
                  block: 'start',
                });
                window.scrollBy(0, -100);
              }, 100);
            }
          }}
        />
      </div>
      <div className="hidden w-full place-content-end pl-2 pt-0 font-extralight text-default-500 lg:hidden">
        Search powered by AI{' '}
        <svg
          xmlns="http://www.w3.org/2000/svg"
          fill="none"
          viewBox="0 0 24 24"
          strokeWidth={0.5}
          stroke={isDarkMode ? 'white' : 'currentColor'}
          className="mt-2 h-4 w-4"
        >
          <path
            strokeLinecap="round"
            strokeLinejoin="round"
            d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
          />
        </svg>
      </div>
    </div>
  );
};

export default ProductSearch;
